import { createStore } from '@stencil/store';
import { State } from 'app/shared/store/models/state.model';

export const store = createStore<State>({
  address: null,
  addProductToCartItem: null,
  bundleElectricitySelected: false,
  bundleGasSelected: false,
  bundleMobilePlanSelected: false,
  bundleNbnSelected: false,
  bundleSearchStore: null,
  cart: null,
  configData: null,
  contentMode: null,
  contractsData: null,
  currentNbnPlan: null,
  currentMobilePlan: null,
  selectedTelcoService: null,
  couponCode: null,
  couponCodes: [],
  delayMessage: null,
  featureStatus: null,
  guidedFlowActiveCategory: 'none',
  focusSku: null,
  hostSpa: null,
  isExplicitBundleFlow: null,
  isGuidedFlow: false,
  flowType: 'default',
  unavailableCategories: null,
  isPageLoaded: false,
  isPersonalisedProductsLoading: false,
  isPromoValid: false,
  modemProductDetails: null,
  productCategory: null,
  productDetails: null,
  promotionPage: null,
  removeProductFromCartItem: null,
  responseError: null,
  showValidIcon: false,
  validationErrors: null,
  voipProductDetails: null,
  skuBeingRemoved: '',
  selectedMobileProductDetails: null,
  selectedNbnProductDetails: null,
  isAuthenticated: false,
  retrieveTriggeredFromRemove: false,
  addressRequired: false,
  selectedPlanCategory: '',
  prefillAddress: false,
  generalContent: {},
  isNbnMovers: false,
  aemCIFIntegrationEnabled: false,
  customerProfile: null,
  webId: null,
  isCampaignPage: false,
  isPromoModalOpen: false,
  promoModalTriggerElementId: null,
  selectedSKU: null,
  isPromoModalDlsOpen: false,
  nbnCommonLinks: null
});
